import { render } from "./FreePlanCard.vue?vue&type=template&id=5937dc3e"
import script from "./FreePlanCard.vue?vue&type=script&lang=js"
export * from "./FreePlanCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__